import { OrderedListOutlined } from "@ant-design/icons";
import { ZeroStatePage } from "components/Dashboard/components/common/ZeroStatePage";
import { EnvironmentDocsContext } from "components/Environment/contexts/EnvironmentDocsContext";
import { SelectedEnvironmentContext } from "components/Environment/contexts/SelectedEnvironmentContext";
import { DOCS_URLS } from "constants/docsUrls";
import { useContext } from "react";

import { AiInventory } from "../components/AiInventory";

export const AiInventoryPage: React.FC = () => {
  const { last } = useContext(SelectedEnvironmentContext);
  const { hasEnvironments } = useContext(EnvironmentDocsContext);

  if (!hasEnvironments) {
    return (
      <ZeroStatePage
        title="Discover AI agents in your environment"
        description="Turn unmanaged agents to managed, and secure their future authentication lifecycle."
        icon={<OrderedListOutlined />}
        docLink={DOCS_URLS.IAM_ASSESSMENT}
      />
    );
  }

  const assessmentId = last.doc?.data.assessmentId;
  const jobId = last.doc?.id;
  const scopes = last.doc?.data.scope;

  if (!assessmentId || !jobId || !scopes) return null;

  return (
    <AiInventory assessmentId={assessmentId} jobId={jobId} scopes={scopes} />
  );
};
